import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { LegalPageLayout } from '../components/LegalPageLayout';
import { SiteHeader } from '../components/SiteHeader';
import { AppFooter } from '../components/AppFooter';
export function CookiePolicy() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-245">
      <Helmet data-id="element-246">
        <title data-id="element-247">Cookie Policy | Affordable Medical Tourism</title>
        <meta name="description" content="How affordablemedicaltourism.com, a product of Kosansh Solutions Inc, uses cookies and similar technologies." data-id="element-248" />
        <link rel="canonical" href="https://affordablemedicaltourism.com/cookie-policy" data-id="element-249" />
      </Helmet>

      <SiteHeader brand="Affordable Medical Tourism" links={[{
      label: 'Procedures',
      href: '/procedures'
    }, {
      label: 'How it works',
      href: '/how-it-works'
    }, {
      label: 'Destinations',
      href: '/destinations'
    }, {
      label: 'FAQ',
      href: '/faq'
    }]} contactCtaLabel="Get a free quote" onContactCta={() => navigate('/contact')} data-id="element-250" />

      <main className="flex-1" data-id="element-251">
        <LegalPageLayout title="Cookie Policy" lastUpdated="June 11, 2026" illustrative={true} intro={<p className="text-lg text-slate-600 mb-8" data-id="element-253">
              This Cookie Policy explains how Kosansh Solutions Inc uses cookies
              and similar technologies on affordablemedicaltourism.com. It
              should be read together with our Privacy Policy, which describes
              how we handle personal data more broadly.
            </p>} sections={[{
        id: 'what-are-cookies',
        heading: '1. What Cookies Are',
        body: <div className="space-y-4 text-slate-600" data-id="element-254">
                  <p data-id="element-255">
                    Cookies are small text files placed on your device when you
                    visit a website. They are widely used to make websites work,
                    to improve efficiency, and to provide information to the
                    site operators. Similar technologies, such as local storage
                    and pixels, perform comparable functions.
                  </p>
                </div>
      }, {
        id: 'how-we-use',
        heading: '2. How We Use Cookies',
        body: <div className="space-y-4 text-slate-600" data-id="element-256">
                  <p data-id="element-257">
                    We use cookies and similar technologies for the following
                    purposes:
                  </p>
                  <ul className="list-disc pl-6 space-y-2" data-id="element-258">
                    <li data-id="element-259">
                      <strong data-id="element-260">Strictly necessary:</strong> to enable core
                      functionality such as page navigation and secure form
                      submission. The site cannot function properly without
                      these.
                    </li>
                    <li data-id="element-261">
                      <strong data-id="element-262">Performance and analytics:</strong> to understand
                      how visitors use the site so we can improve content and
                      usability. These help us measure traffic patterns in
                      aggregate.
                    </li>
                    <li data-id="element-263">
                      <strong data-id="element-264">Preference:</strong> to remember choices you make,
                      such as display settings, to provide a more consistent
                      experience.
                    </li>
                  </ul>
                </div>
      }, {
        id: 'managing',
        heading: '3. Managing Your Preferences',
        body: <div className="space-y-4 text-slate-600" data-id="element-265">
                  <p data-id="element-266">
                    Most browsers allow you to control cookies through their
                    settings. You can usually refuse or delete cookies, although
                    doing so may affect the functionality of this and other
                    websites. The method for managing cookies varies by browser,
                    and your browser help documentation provides specific
                    guidance.
                  </p>
                </div>
      }, {
        id: 'updates',
        heading: '4. Updates and Contact',
        body: <div className="space-y-4 text-slate-600" data-id="element-267">
                  <p data-id="element-268">
                    We may update this Cookie Policy to reflect changes in
                    technology, regulation, or our practices. Material changes
                    will be indicated by updating the date at the top of this
                    page. If you have questions, please contact us through our
                    secure contact form. We do not publish direct email
                    addresses, and all inquiries are handled through that form.
                  </p>
                  <p data-id="element-269">
                    Kosansh Solutions Inc
                    <br data-id="element-270" />
                    Fort Worth, TX
                    <br data-id="element-271" />
                    Phone: 857-567-2674
                  </p>
                </div>
      }]} data-id="element-252" />
      </main>

      <AppFooter data-id="element-272" />
    </div>;
}